import { createAction } from "@reduxjs/toolkit"
import {
  BadgeMargins,
  BadgeSize,
  EditType,
  GridSize,
  PageMargins,
  PagesData,
  PageSize,
  PaperType, TemplateType
} from "@store/reducers/init/types"


export const changeUnitType = createAction("PAPER_CHANGE_UNIT_TYPE")
export const changeCurrentDesign = createAction<any>("PAPER_CHANGE__CURRENT_DESIGN")
export const changeEditType = createAction<EditType>("PAPER_CHANGE__EDIT_TYPE")
export const changeTemplateType = createAction<TemplateType>("PAPER_CHANGE__TEMPLATE_TYPE")

//3rd Party
export const changeThirdPartySettings = createAction<boolean>("PAPER_CHANGE_THIRDPARTY_SETTINGS")
export const changeThirdPartyFormat = createAction<any>("PAPER_CHANGE_THIRDPARTY_FORMAT_SIZE")
export const changeThirdPartyName = createAction("PAPER_CHANGE_THIRDPARTY_NAME")

//formatSize or paperSize
export const changeFormatSize = createAction<BadgeSize>("PAPER_CHANGE__FORMAT_SIZE")
export const changeCustomFormatInputMode = createAction<boolean>("PAPER_changeIsCustomFormatSize")
export const changeCustomPageSizeInputMode = createAction<boolean>("PAPER_changePageSizeCustom")
export const changePageSize = createAction<PageSize>("PAPER_CHANGE_PAGE_SIZE")
export const changePageSizes = createAction<{ [key: string]: PageSize }>("PAPER_changePageSizes")
export const changePaperType = createAction<PaperType>("changePaperType")

//layout
export const changePaperMargins = createAction<PageMargins>("PAPER_changePaperMargins")
export const changeBadgeMargins = createAction<BadgeMargins>("PAPER_changeBadgeMargins")
export const changeCalculatedGridSize = createAction<GridSize>("PAPER_changeCalculatedGridSize")
export const changeCustomGridSize = createAction<GridSize>("PAPER_changeCustomGridSize")

//MoudleSetting
export const changeEnabledModules = createAction<string[]>("PAPER_Change_Enabled_Moudles")

//needConfirmation
export const changeNeedConfirmation = createAction<boolean>("PAPER_CHANGE_NEED_CONFIRMATION")

//Resets
export const resetCanvas = createAction<any>("resetCanvas")
export const resetState = createAction("PAPER_RESET_STATE") //Paint Options

//Page data
export const changePageData = createAction<PagesData>("INIT_CHANGE_BADGE_PAGES")
export const updatePageData = createAction<PagesData>("INIT_UPDATE_BADGE_PAGES")
export const changeSelectedPage = createAction<number>("INIT_CHANGE_SELECTED_PAGE")
export const rerenderGrid = createAction<number>("INIT_RERENDER_GRID")

export const changePageOption = createAction<string>("PAPER_CHANGE_PAGE_OPTION")
export const changeSeperatePage = createAction<string>("PAPER_CHANGE_SEPERATE_PAGE")

export const changeIsAddOnBadge = createAction<any>("PAPER_CHANGE_IS_ADD_ON_BADGE")
export const changeSelectedTags = createAction<any>("PAPER_CHANGE_SELECTED_TAGS")

//Floormap
export const changeIsFloorMap = createAction<boolean>("PAPER_CHANGE_IS_FLOOR_MAP")
export const changeIsAttendeeFloorMap = createAction<boolean>("PAPER_CHANGE_IS_ATTENDEE_FLOOR_MAP")
export const changeShowBackgroundImage = createAction<boolean>("PAPER_CHANGE_SHOW_BACKGROUND_IMAGE")
export const setBoothColorSetting = createAction<any>("SET_BOOTH_SETTINGS_MODAL")

//attendees
export const changeAttendees = createAction<any>("PAPER_CHANGE_ATTENDEES")
export const changeTableDataGlobal = createAction<any>("PAPER_CHANGE_TABLE_DATA_GLOBAL")
export const changeIsTableFinder = createAction<boolean>("PAPER_CHANGE_IS_TABLE_FINDER")
export const changeSelectedPageIndex = createAction<number>("PAPER_CHANGE_SELECTED_PAGE_INDEX")

export const changeSponsorLogos = createAction<boolean>("PAPER_CHANGE_SPONSOR_LOGOS")
export const changeShowBoothRegistration = createAction<boolean>("PAPER_CHANGE_SHOW_BOOTH_REGISTRATION")  
